import React, { useCallback, useState } from 'react'
import { bool, shape } from 'prop-types'
import { useParams } from 'react-router-dom'
import { Switch, Typography, Button } from 'antd'
import { useDispatch } from 'react-redux'

import { changeConfigs } from 'states/modules/documentDetail'

import { ConfigCard } from './styles'
import styles from './index.module.scss'

const Text = Typography.Text

const Configs = ({ configs }) => {
	const dispatch = useDispatch()
	const { id } = useParams()

	const [notificationsEnabled, setNotificationsEnabled] = useState(
		configs.notificationsEnabled || false
	)

	const onChangeNotifications = (checked) => {
		setNotificationsEnabled(checked)
	}

	const handleSaveConfigs = useCallback(() => {
		dispatch(changeConfigs({ id, configs: { notificationsEnabled } }))
	}, [dispatch, id, notificationsEnabled])

	return (
		<div className={styles.configs__container}>
			<div className={styles.configs__header}>
				<h4 className={styles.configs__title}>Configurações do documento</h4>
				<Button type="primary" onClick={handleSaveConfigs}>
					Salvar
				</Button>
			</div>
			<div>
				<ConfigCard
					title="Receber notificações"
					extra={
						<Switch
							checked={notificationsEnabled}
							onChange={onChangeNotifications}
						/>
					}>
					<Text>
						Quando esta opção estiver ativada, você irá receber notificações
						sobre a vigência deste documento semanalmente.
					</Text>
				</ConfigCard>
			</div>
		</div>
	)
}

Configs.propTypes = {
	configs: shape({
		notificationsEnabled: bool,
	}),
}

export default Configs
